import React from 'react'
import { Box } from '@material-ui/core'
import { Muted, TextLink } from './ui'
import { INPUT_LABEL } from '../model/workflow'

// Picked files that do not fit the batch's analysis and input are set aside, never
// dropped (model/samples partitionSamples). One quiet line per group says so, with
// a link that makes that group the batch; the batch's own samples are then set
// aside in turn, so nothing is lost.

/** "3 ONT BAM files", "1 VCF file" */
export const setAsideFiles = (group) => {
  const n = group?.samples?.length || 0
  return `${n} ${INPUT_LABEL[group?.input] || 'other'} ${n === 1 ? 'file' : 'files'}`
}

/** "Not in this batch: 3 ONT BAM files." */
export const setAsideText = (group) => `Not in this batch: ${setAsideFiles(group)}.`

const SetAsideNote = ({ groups, onStart, sx }) => {
  if (!Array.isArray(groups) || !groups.length) return null
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2, px: 1, ...sx }}>
      {groups.map((group) => (
        <Muted key={group.key}>
          {setAsideText(group)}
          {group.note ? ` ${group.note}` : ''}{' '}
          <TextLink onClick={() => onStart(group)}>Start a separate batch with these</TextLink>
        </Muted>
      ))}
    </Box>
  )
}

export default SetAsideNote
